import { useMemo } from "react";
import { mergeStyleSets } from "@fluentui/react/lib/Styling";

export function useContactInfoStyles() {
  const gridStyles = useMemo(
    () => mergeStyleSets({
      headerWrap: {
        height: 0,
        padding: 0,
        margin: 0
      }
    }),
    []
  );

  return {
    gridStyles
  };
}
